import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { useSpaceResource } from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { Badge } from "../../../Badge";
import { BaseView } from "../../BaseView";

const i18nRoot = "settings.workflows.view";
export const ViewSpace = ({ action }) => {
  const { api_params: apiParams } = action || {};
  const { space_id: spaceId } = apiParams || {};
  const { data: space, isLoading } = useSpaceResource({ spaceId });

  if (!space && !isLoading) {
    return null;
  }

  return (
    <BaseView>
      <BaseView.Section>
        <BaseView.Title>{t([i18nRoot, "space"])}</BaseView.Title>
        <div>
          {isLoading ? (
            <Badge isLoading />
          ) : (
            <Typography.LabelSm>{space.name}</Typography.LabelSm>
          )}
        </div>
      </BaseView.Section>
    </BaseView>
  );
};

ViewSpace.propTypes = {
  action: PropTypes.object,
};
